module.exports = __webpack_public_path__ + "static/CalibreWeb-Black-41f12dcf7c1e1afbd630a4e3b9ab0917.woff2";